let navBtn = document.getElementsByClassName('mobile-nav__button')[0];
navBtn.addEventListener('click', () => {
    document.body.classList.toggle('mobile-nav__open');
});

let navOverlay = document.getElementsByClassName('mobile-nav__overlay')[0];
navOverlay.addEventListener('click', () => {
    document.body.classList.toggle('mobile-nav__open');
});